import { render, staticRenderFns } from "./GenrePickerGenre.vue?vue&type=template&id=1fa5e334&"
import script from "./GenrePickerGenre.vue?vue&type=script&lang=js&"
export * from "./GenrePickerGenre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports